import { Component, OnInit, ViewChildren, QueryList, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RowClickedEvent } from 'ag-grid-community';
import { AlertService } from 'src/app/_services/alert.service';
import { UserService } from 'src/app/_services/user.service';
import { environment } from 'src/environments/environment';
import { MerchantService } from '../../merchants/merchant-master/merchant.service';
import { ScreeningUtilityService } from '../screening-utility-service';
import { MenusService } from 'src/app/_services/menu.service';
import {KeyValue, Location} from '@angular/common';
import Swal from 'sweetalert2';
import { CustomerService } from '../../customers/customer-service';
import { firstValueFrom } from 'rxjs';
import { log } from 'console';
const { API_URL } = environment;
interface Dictionary { 
  [index: string]: string 
}

@Component({
  selector: 'app-screening-utility-edit',
  templateUrl: './screening-utility-edit.component.html',
  styleUrls: ['./screening-utility-edit.component.scss']
})
export class ScreeningUtilityEditComponent implements OnInit {
  profileData :any
  addedBy:any
  customerForm: FormGroup
  Resultdata: any;
  param1: any;
  fname: any;
  mobile: any
  emailId: any
  eid: any
  emiratesExpiry: any
  edcMobile: any
  nationality: any
  dob: any
  gender: any
  passportNumber: any
  passportType: any
  passportExpiry: any
  occupation: any
  pob: any
  emirate: any
  poBox: any
  city: any
  areaDesc: any
  isInitiateKycFlag : boolean ;
  isSubmittedKycFlag : boolean;

  relavent : any;
  notRelavent :any;
  remark:any;
  finalRelavency : any


  status: any
  remarkData: any

  mid: any

  emiratesIdImage: any
  screeningReportPdf: any



  // Customer Profile Variables 
  idenfoId : any
  fullname : any
  IdenfoGender : any
  dateOfBirth :any
  countryOfResidence:any
  residenceStatus : any 
  recordLastUpdated: any
  deliveryChannel : any

  //Customer Name Screening Variables
  sanctionHit: boolean
  sanctionHitClass : any
  sanctionHitColor : any

  pepHit: boolean
  pepHitClass: any
  pepHitColor:any

  specialInterestHit: boolean
  specialInterestHitClass: any
  specialInterestHitColor: any

  adverseMediaHit: boolean
  adverseMediaHitClass: any
  adverseMediaHitColor: any

  selfDeclaredHit: boolean
  selfDeclaredHitClass: any
  selfDeclaredHitColor: any

  riskRatingHit: any
  riskRatingHitClass: any
  riskRatingHitColor: any

  enforcementHit: any
  enforcementHitClass: any
  enforcementHitColor: any

  isSelfPepHit: any
  isSelfPepHitClass: any
  isSelfPepHitColor: any


  //Risk Factor
  countryOfResidenceRisk : any
  countryOfResidenceScore : any
  countryOfResidenceLevel : any

  deliveryChannelRisk : any
  deliveryChannelScore : any
  deliveryChannelLevel: any

  industryRisk: any
  industryScore: any
  industryLevel :any

  nationalityRisk: any
  nationalityScore: any
  nationalityLevel: any

  productRisk: any
  productScore: any
  productLevel: any

  stateRisk: any
  stateScore: any
  stateLevel: any

  baseRatingRisk: any


  suspiciousActivityReportsRisk: any
  suspiciousActivityReportsScore: any
  suspiciousActivityReportsLevel: any

  nonResidentRisk: any
  nonResidentScore: any
  nonResidentLevel: any

  residenceCountryIsSanctionedRisk: any
  residenceCountryIsSanctionedScore: any
  residenceCountryIsSanctionedLevel: any


  nameScreeningHitSanction : String[]
  nameScreeningHitPep : Boolean
  nameScreeningHitSpecialInterest : any
  nameScreeningHitAdverseMedia : Boolean
  nameScreeningHitDetermination: String

  sanctionScore : any;
  sanctionLevel : any;
  baseRatingLevel : any
  overAllRating :any

  datatableDob: any
  datatableNationality : any
  
  na : any

  nameScreeningHitsLength: number;
  nameScreeningHitsData: any;
  associations : any[];
  mediaData : any[];
  fieldsData : any[];
  keywordList : any[];
  screeningConfig : any;
  screeningBy : any;
  dobScreening : any;
  public permissions: any;
  reviewFlag : any;
  saveReviewFlag:any;
  saveFlag:boolean;
  map : Map<string, any>;
  screeningId:any;
  @Input() mobileNumber: String = "";
  selectedTab: number=0;
  @ViewChildren('rowElement') rowElements!: QueryList<any>; // Get a reference to all table rows

  constructor(private modalService : NgbModal, private route: ActivatedRoute, private domSanitizer: DomSanitizer,private alertService : AlertService,private userService:UserService,private utilityService : ScreeningUtilityService,private location:Location,private menuService: MenusService,private router: Router) {

  }
  ngOnInit(): void {
    this.isInitiateKycFlag = false;
    this.isSubmittedKycFlag = false;
    this.userService.getUserProfileNew().subscribe((data) => {
      console.log("Profile :"+JSON.stringify(data));
      
      this.addedBy = data.fullName;
      console.log("Added By :"+this.addedBy);
    });
    this.selectedTab = 2;
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions);
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
       this.router.navigateByUrl('/');
    }

 
  
    this.mid = this.route.snapshot.queryParamMap.get("mid");
    this.utilityService.getUtilityResponseById(this.mid).subscribe((res: any) => {
      this.Resultdata = res.response.data;
      this.reviewFlag = res.response.data.reviewFlag;
      console.log(this.reviewFlag);
      console.log(this.permissions);
      if(this.permissions == "Maker Review" && this.reviewFlag == 0){
        console.log("Enable Initiate Review Button for maker");
        this.isInitiateKycFlag = true;
        this.saveReviewFlag = 1;
        this.isShowInitiate = false;
        
        
      }else if (this.permissions == "Maker Review" && this.reviewFlag == 1){
        console.log("Enable Submit Review Button for maker");
        this.isSubmittedKycFlag = true;
        this.saveReviewFlag = 2;
        this.isShowInitiate= true;
        this.saveFlag = true;

      }else if(this.permissions == "Checker Review" && this.reviewFlag == 2){
        console.log("Enable Initiate Review Button for maker");
        this.isInitiateKycFlag = true;
        this.saveReviewFlag = 3;
        this.isShowInitiate= false;
  
      }else if(this.permissions == "Checker Review" && this.reviewFlag == 3){
        console.log("Enable Submit Review Button for maker");
        this.isSubmittedKycFlag = true;
        this.saveReviewFlag = 4;
        this.isShowInitiate= true;
        this.saveFlag = true;
  
      }

      this.screeningId = res.response.data?.screeningId;
      this.fullname =res.response.data.data?.data.fullName;
      this.screeningConfig = res.response.data.screeningConfiguration;
      this.screeningBy = res.response.data.screeningBy;
      this.dobScreening = res.response.data.dob;
      this.countryOfResidence = res.response.data.country;
      this.residenceStatus = "Rent";
      this.fname = this.fullname;
      this.getActivityTimeline(this.screeningId);

      if(this.sanctionHit){
        this.sanctionHitClass = "feather icon-x-circle";
        this.sanctionHitColor = "color: red;"
      }else{
        this.sanctionHitClass = "feather icon-check";
        this.sanctionHitColor = "color: green;"
      }

      if(this.pepHit){
        this.pepHitClass = "feather icon-x-circle";
        this.pepHitColor= "color: red;"
      }else{
        this.pepHitClass = "feather icon-check";
        this.pepHitColor= "color: green;"
      }

      if(this.adverseMediaHit){
        this.adverseMediaHitClass = "feather icon-x-circle";
        this.adverseMediaHitColor= "color: red;"
      }else{
        this.adverseMediaHitClass = "feather icon-check";
        this.adverseMediaHitColor= "color: green;"
      }

      if(this.riskRatingHit=="sanction"){
        this.riskRatingHit = "Sanctioned";
        this.riskRatingHitClass = "feather icon-x-circle";
        this.riskRatingHitColor= "color: red;"
      }else{
        this.riskRatingHit = "Low";
        this.riskRatingHitClass = "feather icon-check";
        this.riskRatingHitColor= "color: green;"
      }

      if(this.enforcementHit){
        this.enforcementHitClass = "feather icon-x-circle";
        this.enforcementHitColor= "color: red;"
      }else{
        this.enforcementHitClass = "feather icon-check";
        this.enforcementHitColor= "color: green;"
      }

      if(this.isSelfPepHit == "low" || this.isSelfPepHit == "" || this.isSelfPepHit == undefined){
        this.isSelfPepHitClass = "feather icon-check";
        this.isSelfPepHitColor= "color: green;"
      }else{
        this.isSelfPepHitClass = "feather icon-x-circle";
        this.isSelfPepHitColor= "color: red;"
      }

      console.log("Sanction Hit : "+this.sanctionHitColor+this.pepHit+this.adverseMediaHit+this.riskRatingHit);
      console.log(res.response.data.riskRatings);
      if(res.response.data.riskRatings != undefined){
        this.countryOfResidenceScore = res.response.data.riskRatings[0].number;
      this.countryOfResidenceLevel = res.response.data.riskRatings[0].level+" Risk";
 
      this.deliveryChannelScore = res.response.data.riskRatings[3].number;
      this.deliveryChannelLevel = res.response.data.riskRatings[3].level+" Risk";

      this.industryScore = res.response.data.riskRatings[6].number;
      this.industryLevel = res.response.data.riskRatings[6].level+" Risk";

      this.nationalityScore = res.response.data.riskRatings[8].number;
      this.nationalityLevel = res.response.data.riskRatings[8].level+" Risk";

      this.productScore = res.response.data.riskRatings[10].number;
      this.productLevel = res.response.data.riskRatings[10].level+" Risk";

      this.stateScore = res.response.data.riskRatings[11].number;
      this.stateLevel = res.response.data.riskRatings[11].level+" Risk";

      this.suspiciousActivityReportsScore = res.response.data.riskRatings[12].overRideTo;
      this.suspiciousActivityReportsLevel = res.response.data.riskRatings[12].level+" Risk";

      this.nonResidentScore = res.response.data.riskRatings[13].overRideTo;
      this.nonResidentLevel = res.response.data.riskRatings[13].level+" Risk";

      this.residenceCountryIsSanctionedScore = res.response.data.riskRatings[14].overRideTo;
      this.residenceCountryIsSanctionedLevel = res.response.data.riskRatings[14].level+" Risk";

      this.suspiciousActivityReportsScore = res.response.data.riskRatings[12].overRideTo;
      this.suspiciousActivityReportsLevel = res.response.data.riskRatings[12].level+" Risk";

      this.sanctionScore = res.response.data.riskRatings[17].overRideTo;
      this.sanctionLevel = res.response.data.riskRatings[17].level+" Risk";

      if(this.sanctionScore == "sanction"){
        this.sanctionScore = "Sanctioned";
        this.sanctionLevel = "Sanctioned"
      }else{
        this.sanctionScore = "Low Risk";
        this.sanctionLevel = "Low Risk"
      }

      this.baseRatingLevel =  res.response.data.kycSummary.riskLevel+" Risk";

      this.overAllRating =  res.response.data.kycSummary.riskRating;
      if(this.overAllRating == "sanction"){
        this.overAllRating = "Sanctioned";
      }else{
        this.overAllRating = "Low Risk";
      }
      }

      console.log("length : "+res.response.data.data?.data.nameScreeningHits.length);

      this.nameScreeningHitsData = res.response.data.data?.data.nameScreeningHits;
      this.nameScreeningHitsLength = res.response.data.data?.data.nameScreeningHits.length;
      // this.datatableDob = this.nameScreeningHitsData[this.nameScreeningHitsLength].screeningData.dob[0].dob;

    });

    

   
      
  }

  ngAfterViewInit(): void {
    // Scroll to the selected row after the view initializes (only if the table is visible)
    if (this.selectedRow !== null && this.tableVisible) {
      this.scrollToSelectedRow();
    }

  }

  activeTab = 'customerProfile'; // Default active tab
  activeTabSub='profile';


  switchTab(tab: string): void {
    this.activeTab = tab;
    this.tableVisible = true;
    if(tab == "nameScreening"){
      console.log(this.screeningId);
      this.utilityService.getCustomerNameScreeningById(this.screeningId).subscribe((res: any) => {
        console.log("Name Screening Remark : "+JSON.stringify(res.response.data));
        this.getSavedNameScreeningLength=res.response.data.length;
        console.log("Name Screening Remark Length : "+res.response.data.length);
        this.map = new Map();
        for(var i=0;i<res.response.data.length;i++){
          this.map.set(res.response.data[i].referenceId, res.response.data[i])    
        }
      });
    }
    
  }

  namePoints : any
  scoreObjectRes : any
  openScoreBreakdown(content: any,row:any,scoreObject : any) {
    console.log("Content Row : "+row);
  

    console.log("Keywords : "+this.nameScreeningHitsData[row].screeningData.keyword);
    this.scoreObjectRes = scoreObject;
    


    this.selectedRow = row;
    this.modalService.open(content, { centered: true });
    
  }

  switchTabSub(tab: string): void {
    this.activeTabSub = tab;
    this.tableVisible = false;
  }

  rowSelectProfile(item:any, nameScreeningHitsLength: Number){
    console.log("Item :"+item);
    console.log("Which row :"+nameScreeningHitsLength);
  }

  tableVisible: boolean = false; // Initially set to true to show the table

  isGenuine: boolean = false;
  isRelevant: boolean = true;
  selectedRow : number
  extraInfoObject: any ;
  keywords: any;

  toggleTableVisibility(param: RowClickedEvent | any,row : any) {
    this.tableVisible = !this.tableVisible; // Toggle visibility
    console.log("Row Clicked", param);
    console.log("Fullname : "+JSON.stringify(this.nameScreeningHitsData[row]));
    console.log("Which row selected : "+row);

    // console.log("keyword : "+this.nameScreeningHitsData[row].screeningData.keyword[0]);
    // console.log("Description : "+this.nameScreeningHitsData[row].screeningData.description1[0].value);

    
    
    this.selectedRow = row;
    console.log("Extra Info :"+JSON.stringify(this.nameScreeningHitsData[this.selectedRow].screeningData.extra_info));
    this.associations = this.nameScreeningHitsData[row].associates;
    console.log("Associations : "+JSON.stringify(this.associations));
    this.mediaData = this.nameScreeningHitsData[row].media;
    console.log("Media : "+JSON.stringify(this.mediaData));
    this.fieldsData = this.nameScreeningHitsData[row].fields;
    console.log("Fields : "+JSON.stringify(this.fieldsData));
    for(let i:number = 0; i<this.fieldsData.length;i++){
      console.log(this.fieldsData[i]);
      for (let key in this.fieldsData[i]) {
        console.log(key);
      }
    }
    this.extraInfoObject = this.nameScreeningHitsData[this.selectedRow].screeningData.extra_info;
    // this.keywords = this.nameScreeningHitsData[row].screeningData.keyword[0];
    console.log("Extra Info :"+JSON.stringify(this.extraInfoObject));
    console.log("Designation  : "+this.nameScreeningHitsData[this.selectedRow].screeningData.role_type);
    
  }


  kycComment:any
  selectedStatus: any
  narrationKyc:any
  typeKyc:any
  userType :any;
    
  async submitKycReview(){
    console.log("Status :"+this.selectedStatus);
    console.log("Comment :"+this.kycComment);

    if(this.selectedStatus!=undefined && this.kycComment!=undefined && this.kycComment!= ""){
      if(this.reviewFlag==0 || this.reviewFlag==1 ){
        this.userType = "L1 (Maker)";
      }
      else{
        this.userType = "L2 (Checker)";
      }
      console.log("Review Flag : "+this.reviewFlag);
      console.log("Selected Status : "+this.selectedStatus);
      if(this.selectedStatus == "ACCEPTED" && this.reviewFlag==3){
        let statusChangeRequest = {
          "userId" : this.mid,
          "status" : "APPROVED", 
          "remark" : this.kycComment
        }
        const response = await firstValueFrom(this.utilityService.updateUtilityKycStatusChange(statusChangeRequest));
        console.log(response);
      }else if(this.selectedStatus == "REJECTED" && this.reviewFlag==3){
        let statusChangeRequest = {
          "userId" : this.mid,
          "status" : "REJECTED", 
          "remark" : this.kycComment
        }
        const response = await firstValueFrom(this.utilityService.updateUtilityKycStatusChange(statusChangeRequest));
        console.log(response);
      }
    this.narrationKyc = this.userType+" Submitted Screening Review Status and changed KYC Status to "+this.selectedStatus+" with the following comment : "+this.kycComment,
    this.typeKyc = "System Generated";
    this.updateReviewKycFlag(this.saveReviewFlag,this.mid);
    this.saveActivityTimeline(this.screeningId,this.fullname,this.narrationKyc,this.typeKyc,this.addedBy);
    this.modalService.dismissAll();
    this.alertService.successAlert("Screening Review Submitted Successfully");
    }
  }

  get isMaxLengthExceeded(): boolean {
    return this.kycComment.length > 255;
  }

  saveActivityTimeline(screeningId:any,fullname:any,narration:any,type:any,addedBy:any){
    let requestForm ={
      "screeningId" : screeningId,
      "fullName" : fullname,
      "narration" : narration,
      "type" : type,
      "addedBy" : addedBy,
    }

    this.utilityService.saveActivityTimeline(requestForm).subscribe((data) => {
      console.log("Response" + JSON.stringify(data));
      // this.alertService.successAlert(data);
    }
    );
  }

  updateReviewKycFlag(flag:any,mobile:any){
    this.utilityService.updateReviewFlag(flag,mobile).subscribe((data) => {
      console.log("updateReviewFlag" +data);
      this.ngOnInit();
      this.selectedTab = 2;
    });
  }

  toggleTableVisibility1() {
    // Toggle the table visibility
    this.tableVisible = !this.tableVisible;

    if (this.tableVisible && this.selectedRow !== null) {
      // Restore the table to the selected row if it's visible
      console.log("Restoring row: ", this.selectedRow);
      setTimeout(() => this.scrollToSelectedRow(), 0); // Use a timeout to ensure the DOM is updated
    } else {
      // Reset or clear selected row when hiding the table
      this.selectedRow=0 ;
    }
  }

  scrollToSelectedRow() {
    const row = this.rowElements.toArray()[this.selectedRow];
    if (row) {
      row.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  keys(): Array<string> { 
    if(this.extraInfoObject){
      return Object.keys(this.extraInfoObject); 
    }else{
      return []
    }
} 

keyword(obj : any): Array<string> { 
  console.log(JSON.parse(obj));
  if(obj)
    console.log(Object.keys(JSON.parse(obj)));
  
  if(obj){
    return Object.keys(JSON.parse(obj)); 
  }else{
    return []
  }
} 




  onRowClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked", param);
  }

  getIconFromString(val: String){

    // console.log(val);
    if(val == "sanction"){
      return "feather icon-x-circle";
    }else{
    return "feather icon-check";
    }
  }

  getIconFromStringCondition(val: String){

    // console.log(val);
    if(val == "false"){
      return "feather icon-check";
    }else{
    return "feather icon-x-circle";
    }
  }

  saveRemarks(item:any,length:any){
      const radioElement = document.querySelector('input[name="nshRadio' + length + '"]:checked') as HTMLInputElement;
      const  relavancy = radioElement ? radioElement.value : null;
  
      const remarksElement = document.querySelector('input[name="remark' + length + '"]') as HTMLInputElement;
      const  remarks = remarksElement ? remarksElement.value : null;
  
      // const remarksIcon = document.querySelector('input[id="saveRemarkIcon' + length + '"]') as HTMLInputElement;
      // if(remarksIcon) {   remarksIcon.disabled = true;
      // }

      if (remarks === "" || remarks === null || remarks.trim() === "") {
        this.alertService.toastErrorMessageAlert({titleText:"Remarks field is required"})
        return;
      }

      if (relavancy === null || relavancy === "") {
        this.alertService.toastErrorMessageAlert({titleText:"Relevancy field is required"})
        return; 
      }
  
      if(this.saveFlag){
      const saveRemarkIcon = document.getElementById('saveRemarkIcon'+ length);
      if(saveRemarkIcon) {   
        saveRemarkIcon.setAttribute('data-disabled','true'); 
      }
    
      console.log("Relavency :"+relavancy);
      console.log("Comment : "+remarks);
      let requestForm= {
        "screeningId" : this.screeningId,
        "mobileNumber" : this.mid,
        "relevancy" : relavancy,
        "remark" : remarks,
        "referenceId" : item._id,
        "addedBy" : this.addedBy
    }
    
      this.utilityService.saveNameScreeningRemark(requestForm).subscribe((data:any) => {
        console.log("Response" + JSON.stringify(data));
        if(data.response.message == "Name Screening Remark saved successfully"){
          Swal.fire('Name Screening Remark saved successfully','','success')
          this.utilityService.getCustomerNameScreeningById(this.screeningId).subscribe((res: any) => {
            console.log("Name Screening Remark Length : "+res.response.data.length);
            this.getSavedNameScreeningLength=res.response.data.length;
          });
        }else{
          Swal.fire('Error while saving Name Screening Remark','','error')
        }
      });
    }else{
      console.log("No data to be saved for name screening remark 1" );
    }
  
    }

  getIconFromBoolean(val: String){

    console.log(val);
    if(val == "true"){
      return "feather icon-x-circle";
    }else{
    return "feather icon-check";
    }
  }
 
  toggleRelevance(isRelevant: boolean) {
    this.isRelevant = isRelevant;
  }

  toggleGenuine() {
    this.isGenuine = !this.isGenuine;
  }

  isShowInitiate: boolean = false;
  showInitiatePop(cont: any){

    this.modalService.open(cont, { centered: true });

  }

  getSavedNameScreeningLength:any;
  showKycPop(cont:any){
    if(this.getSavedNameScreeningLength==this.nameScreeningHitsLength){
      this.modalService.open(cont, { centered: true });
    }else{
      Swal.fire('Please select relevancy for all alerts before submitting the review.',"", 'warning');
    }
  }

  narration:any
  type:any
  userType1:any;
  showInitiate(cont: any){

    
    this.type = "System Generated";
    if(this.reviewFlag==0 || this.reviewFlag==1 ){

      this.userType1 = "L1 (Maker)";
    }else{
      this.userType1 = "L2 (Checker)";
    }
    this.narration = "Initiated "+this.userType1+" Review Process";

    this.updateReviewKycFlag(this.saveReviewFlag,this.mid);
    this.saveActivityTimeline(this.screeningId,this.fullname,this.narration,this.type,this.addedBy)
    this.modalService.dismissAll(cont);
    // this.isShowInitiate=true;
    // console.log("name screening length : "+this.nameScreeningHitsLength);
    // for (let i = 0; i < this.nameScreeningHitsLength; i++) {
    //   const saveRemarkIcon = document.getElementById('saveRemarkIcon' + i);   
    //   if (saveRemarkIcon) {      
    //      saveRemarkIcon.setAttribute('data-disabled', 'false'); 
    //     }
    // }
    this.alertService.successAlert("Screening Review Initiated Succsessfully");
  }
  hideInitiate(){
this.isShowInitiate=false;
  }

  activityLength :any
  activityData :any
  reversedList: Array<any> = [];

  getActivityTimeline(screeningId : any){
    this.utilityService.getUtilityActivityResponseById(screeningId).subscribe((data:any) => {
      console.log("Response" + JSON.stringify(data.response.data));
      this.activityLength = data.response.data.length;
      console.log("activityLength" + this.activityLength);
      this.activityData = data.response.data;
      this.reversedList = this.activityData.slice().reverse();
      this.map = new Map();
      for(var i=0;i<data.response.data.length;i++){
        this.map.set(data.response.data[i].referenceId, data.response.data[i])    
      }
    }
    );

  }


  


  getFormattedDate(epochMilli:any) {
    var d = new Date(0);
    d.setUTCMilliseconds(epochMilli);
    console.log(d.toISOString().slice(0,10))
    return d.toISOString().slice(0,10)
  }

  showKeywordModal(cont:any,keyword : any){
    var dummmy = keyword[0];
    this.keywordList = [];
    console.log(dummmy);
    this.keywordList = dummmy.split(",");
    console.log(this.keywordList);
    this.modalService.open(cont, { centered: true });
  }

  getCountryNames(data: any): string {
    const countries = data?.screeningData?.country;
    if (!countries || !Array.isArray(countries) || countries.length === 0) {
      return 'N/A';
    }
  
    const names = countries
      .map((c: any) => c?.name)
      .filter((name: string | null | undefined) => !!name);
  
    return names.length > 0 ? names.join(', ') : 'N/A';
  }
  
}
